export const CURRENCIES = {
  BRL: "BRL",
  USD: "USD",
};

export const SUPPORTED_CURRENCIES = Object.values(CURRENCIES);

export const DEFAULT_DISPLAY_CURRENCY = CURRENCIES.USD;

export const DEFAULT_USD_BRL_RATE = 5;

export const CURRENCY_LABELS = {
  [CURRENCIES.BRL]: "BRL",
  [CURRENCIES.USD]: "USD",
};
